import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsDeleteApi, AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import { CustomButton } from "../../CustomButtom";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { CSVLink } from "react-csv";

export default function AllNFDINStudentsAttendance() {
  const [Projects1, setProjects1] = React.useState([])
  const [Projects2, setProjects2] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [KiratData1, setKiratData1] = React.useState([])
  const [KiratData2, setKiratData2] = React.useState([])
  const [Category, setCategory] = React.useState("")
  const [CustomersList2, setCustomersList2] = React.useState([])
  const [CustomersNasu, setCustomersNasu] = React.useState([])
  const [CustomersOfficer, setCustomersOfficer] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [toStudentModel, setToStudentModal] = React.useState(false)
  const [ChangeToStudentBatchModal, setChangeToStudentBatchModal] = React.useState(false)
  const [ImportData, setImportData] = React.useState([])
  const fileRefSingle = React.createRef();
  const [batchID, setBatchID] = React.useState("")
  const [batchName, setBatchName] = React.useState("")
  const [batchList, setBatchList] = React.useState([])
  const [DateAttendence, setDateAttendence] = React.useState("")
  const [CustomersDownload, setCustomersDownload] = React.useState([])

  var date = new Date()
  var today = date.toLocaleDateString()

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_user_data)
      .then((res) => {
        // var alldata = res.data.filter(a => a.meta.user_name.includes("NFDIN"));
        var alldata = res.data;
        var kiratdata = res.data.filter(a => a.meta.user_name.includes("NKR"));
        setKiratData1(kiratdata.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        setKiratData2(kiratdata.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        setProjects1(alldata.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        setCustomersList(alldata.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        setCustomersList2(alldata.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        setCustomersOfficer(alldata.filter(a => a.meta.nfdin == "officer"))
        setCustomersOfficer(alldata.filter(a => a.meta.nfdin == "nasu"))
        // setProjects1(res.data)
        // setCustomersList(res.data)
        // console.log(res.data[0].meta.user_name)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  const GetAll = () => {
    GetAllProjects({
      per_page: 4999,
      "filter[meta_query][1][key]": "nfdin",
      "filter[meta_query][1][value][0]": `nasu`,
      "filter[meta_query][1][compare]": "==",
      "filter[meta_query][relation]": "OR",
      "filter[meta_query][2][key]": "nfdin",
      "filter[meta_query][2][value][0]": `officer`,
      "filter[meta_query][2][compare]": "==",
    })
  }
  useEffect(() => {
    GetAll()
  }, [])

  const StudentExportRef = React.useRef(null);
  const StudentExportPrint = useReactToPrint({
    content: () => StudentExportRef.current,
    pageStyle: { margin: 0 }

  })

  const StudentExportRef2 = React.useRef(null);
  const StudentExportPrint2 = useReactToPrint({
    content: () => StudentExportRef2.current,
    pageStyle: { margin: 0 }

  })

  const columns = [
    {
      id: 1,
      name: "id",
      selector: (row) => row.meta.user_id,
      sortable: true,
      reorder: true,
      width: "100px"
    },
    {
      id: 31,
      name: "Title",
      selector: (row) => row.title.rendered,
      sortable: true,
      reorder: true,
      width: "150px"

    },
    {
      id: 312,
      name: "Phone",
      selector: (row) => row.meta.user_phone_number,
      sortable: true,
      reorder: true,
      width: "150px"
    },
    {
      id: 32,
      name: "username",
      selector: (row) => row.meta.user_name,
      sortable: true,
      reorder: true
    },
    {
      id: 32,
      name: "role",
      selector: (row) => JSON.parse(row.meta.attendance).length,
      sortable: true,
      reorder: true
    },
    {
      id: 3,
      name: "View",
      cell: (row) => <Link to={`${slugs.student_details}${row.slug}`}>View</Link>,

    }
  ];

  const isoToDmy = (iso) => {
    if (!iso) return "";
    console.log(iso)
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`; // DD/MM/YYYY
  };
  const isoToDmyNumber = (iso) => {
    if (!iso) return "";
    console.log(iso)
    const [y, m, d] = iso.split("-");
    return `${Number(m)}/${d}/${y}`; // DD/MM/YYYY
  };

  const dmyToIso = (dmy) => {
    if (!dmy) return "";
    const [d, m, y] = dmy.split("/");
    const dd = String(d).padStart(2, "0");
    const mm = String(m).padStart(2, "0");
    return `${y}-${mm}-${dd}`; // YYYY-MM-DD
  };
  // const inputValueISO = useMemo(() => dmyToIso(dateDMY), [dateDMY]);

  const handleChange = (e) => {
    const iso = e.target.value       // "YYYY-MM-DD"
    const dmy = isoToDmy(iso);           // "DD/MM/YYYY"
    const dmy2 = isoToDmyNumber(iso);
    console.log("await", dmy, dmy2)
    setDateAttendence(iso)
    // console.log(CustomersList[0].meta.attendance)

    setProjects1(CustomersList.filter(a => a.meta.attendance.includes(dmy) || a.meta.attendance.includes(dmy2)))
    // setDateDMY(dmy);                     // ✅ set on change
  };

  const sortForDownload = (DataArray) => {
    var dData = []
    for (let i = 0; i < DataArray.length; i++) {
      var item = DataArray[i]
      dData.push({
        id: item.id,
        name: item.title.rendered,
        phone_number: item.meta.user_phone_number,
        roll_number: item.meta.user_name,
        attendance: item.meta.attendance == "" ? 0 : JSON.parse(item.meta.attendance).length,
        attendance_date: item.meta.attendance
      })
    }
    setCustomersDownload(dData)
    console.log("done", dData)
  }

  const headers = [
    { label: "Name", key: "name" },
    { label: "Phone Number", key: "phone_number" },
    { label: "Roll Number", key: "roll_number" },
    { label: "Attendance", key: "attendance" },
    { label: "AttendanceDate", key: "attendance_date" },
  ];


  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Students</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Students
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                setProjects1(CustomersList2)
                setCustomersList2(CustomersList2)
                setCategory("")
                sortForDownload(CustomersList2)
              }}
            >
              All ({CustomersList2.length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                var list = CustomersList2.filter(a => a.meta.nfdin == "nasu")
                setProjects1(list)
                setCustomersList(list)
                sortForDownload(list)
                setCategory("Nasu")
              }}
            >
              Nasu ({CustomersList2.filter(a => a.meta.nfdin == "nasu").length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                var list = CustomersList2.filter(a => a.meta.nfdin == "officer")
                setProjects1(list)
                setCustomersList(list)
                sortForDownload(list)
                setCategory("Officer")
              }}
            >
              Officer ({CustomersList2.filter(a => a.meta.nfdin == "officer").length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                // setProjects1(KiratData1)
                // setCustomersList(KiratData1)
                var list = KiratData1
                setProjects1(list)
                setCustomersList(list)
                sortForDownload(list)
                setCategory("Kirati")
              }}
            >
              Kirati ({KiratData1.length}) |
            </div>
            {/* <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                setProjects1(CustomersList2)
                setCustomersList(CustomersList2)
                setCategory("Kirati")
              }}
            >Clear | </div> */}
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
            >
              <input placeholder="Other"
                onChange={e => {
                  var list = CustomersList2.filter(a => a.meta.user_name.includes(e.target.value))
                  setProjects1(list)
                  setCustomersList(list)
                  sortForDownload(list)
                  // setProjects1(CustomersList2.filter(a => a.meta.user_name.includes(e.target.value)))
                  // setCustomersList(CustomersList2.filter(a => a.meta.user_name.includes(e.target.value)))
                  setCategory("")
                }}
              />
            </div>
            <div style={{ display: "inline-block" }}>
              <input
                type="date"
                onChange={handleChange}
              />
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                StudentExportPrint()
              }}
            >
              Print |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                // StudentExportPrint2()
              }}
            >
              {/* Download Excel */}
              <CSVLink data={CustomersDownload} headers={headers} className="Link"
                filename={`StudentData-${date.toLocaleString()}.csv`}
              >

                Download Excel
              </CSVLink>
            </div>
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <div  >
          <div>Attendance for {Category} -  {DateAttendence}: {Projects1.length}</div>
          <table>
            <thead>
              <tr>
                <td>SN</td>
                <td>Name</td>
                <td>Roll Number</td>
                <td>Phone Number</td>
                <td>Attendance</td>
                <td>Today</td>
              </tr>
            </thead>
            {Projects1.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.title.rendered}</td>
                <td>{item.meta.user_name}</td>
                <td>{item.meta.user_phone_number}</td>
                {/* <td>{JSON.parse(item.meta.attendance).length}</td> */}
                <td>
                  {
                    item.meta.attendance == "" ? 0 :
                      JSON.parse(item.meta.attendance).length
                  }</td>
                <td>
                  {
                    item.meta.attendance == "" ? "Absent" :
                      JSON.parse(item.meta.attendance).filter(a => a == `${today}`).length == 0 ? "Absent" : "Present"
                  }
                </td>
              </tr>
            ))}
          </table>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <div ref={StudentExportRef} >
          <div>Attendance for {Category} - {DateAttendence}: {Projects1.length}</div>
          <table>
            <thead>
              <tr>
                <td>SN</td>
                <td>Name</td>
                <td>Roll Number</td>
                <td>Phone Number</td>
                <td>Present List</td>
              </tr>
            </thead>
            {Projects1.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.title.rendered}</td>
                <td>{item.meta.user_name}</td>
                <td>{item.meta.user_phone_number}</td>
                <td>Present</td>
                {/* <td>{JSON.parse(item.meta.attendance).length}</td> */}
              </tr>
            ))}
          </table>
        </div>
      </div>

      <div
        style={{ display: "none" }}
      >
        <div ref={StudentExportRef2} >
          <div>Attendance for {Category} - {DateAttendence}: {Projects1.length}</div>
          <table>
            <thead>
              <tr>
                <td>SN</td>
                <td>Name</td>
                <td>Roll Number</td>
                <td>Phone Number</td>
                <td>Attendance</td>
              </tr>
            </thead>
            {Projects1.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.title.rendered}</td>
                <td>{item.meta.user_name}</td>
                <td>{item.meta.user_phone_number}</td>
                <td>
                  {
                    item.meta.attendance == "" ? 0 :
                      JSON.parse(item.meta.attendance).length}
                </td>
                {/* <td>{JSON.parse(item.meta.attendance).length}</td> */}
              </tr>
            ))}
          </table>
        </div>
      </div>

      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }


    </div>
  )
}


const GetTotal = (Projects1) => {
  var ValidAttendance = Projects1.filter(a => a.meta.attendance !== "")
  var TodayPresent = 0;

  var date = new Date()
  var today = date.toLocaleDateString()


  const isoToDmy = (iso) => {
    if (!iso) return "";
    const [d, m, y] = iso.split("/");
    return `${m}/${d}/${y}`; // DD/MM/YYYY
  };
  var todav2y = isoToDmy(today)
  console.log(todav2y)
  for (let i = 0; i < ValidAttendance.length; i++) {
    if (JSON.parse(ValidAttendance[i].meta.attendance).filter(a => a == `${today}` || a == `${todav2y}`).length !== 0)
      TodayPresent++
    // console.log(JSON.parse(ValidAttendance[i].meta.attendance).filter(a => a == `${today}`))
  }
  return TodayPresent

}